import axios from 'axios'
import CryptoJs from '@Src/utils/service/crypto.service';
import { store, persistor } from '@Src/app/store';
import { clearUserData, setLoginRefreshToken, setLoginToken } from '@App/reducers/auth/loginSlice';
import { clearCoursePreferences } from '@App/reducers/auth/coursePreferencesSlice';
import { jwtDecode } from 'jwt-decode';
import { refreshUserToken } from './service/services/service';

const cryptoJs = new CryptoJs();

const isTokenExpired = async (token: string): Promise<boolean> => {
    const { loginRefreshToken } = store.getState().login;

    //------------------only change after all testing so be careful start----------------
    if (!loginRefreshToken) {
        return true;
    }
    //------------------only change after all testing so be careful end----------------

    try {
        const decodedToken = jwtDecode<{ exp: number }>(token);
        const decodedRefreshToken = jwtDecode<{ exp: number }>(loginRefreshToken);
        if (decodedToken.exp < Math.floor(Date.now() / 1000)) {
            if (decodedRefreshToken.exp < Math.floor(Date.now() / 1000)) {
                return true;
            } else {
                try {
                    const response = await refreshUserToken({ refresh_token: loginRefreshToken });
                    if (response?.ResponseType === 'SUCCESS' && response.data.length > 0) {
                        const newToken = response.data[0].token;
                        const newRefreshToken = response.data[0].refreshToken;
                        store.dispatch(setLoginToken(newToken));
                        store.dispatch(setLoginRefreshToken(newRefreshToken));
                        return false;
                    } else {
                        return true;
                    }
                } catch (error) {
                    console.error("Error refreshing token:", error);
                    return true;
                }

            }
        }
        else {
            return false;
        }
    } catch {
        return true;
    }

};

const logoutUser = async () => {
    store.dispatch(clearUserData());
    store.dispatch(clearCoursePreferences());
    try {
        await persistor.purge();
    } catch (error) {
        console.error("Persistor purge error:", error);
    }
    localStorage.removeItem('persist:root');
    localStorage.removeItem('redirectAfterSubscription');
    window.location.replace(`${process.env.REACT_APP_MAIN_SITE_URL}?logout=true`);
};

const BaseService = axios.create({
    timeout: 60000,
    baseURL: process.env.REACT_APP_BASE_API_URL,
})


// BaseService.interceptors.request.use((config: any) => {
//     if (config.encrypt) {
//         config.headers['encrypt'] = true;
//         config.data = {
//             'encodedPayload': cryptoJs.encrypt(JSON.stringify(config.data))
//         }
//     }
//     const { loginToken } = store.getState().login;
//     console.log("aaaaaaaaaaaaaaaaaaaaaaaaaaa", (isTokenExpired(loginToken)))
//     if (loginToken && isTokenExpired(loginToken)) {
//         logoutUser();
//         return Promise.reject(new Error('Token expired'));
//     }
//     config.headers['authorization'] = loginToken;
//     return config;
// }, error => {
//     return Promise.reject(error)
// })

BaseService.interceptors.request.use(async (config: any) => {

    if (config.encrypt) {
        config.headers['encrypt'] = true;
        config.data = {
            encodedPayload: cryptoJs.encrypt(JSON.stringify(config.data))
        };
    }

    const { loginToken } = store.getState().login;

    if (loginToken) {
        const expired = await isTokenExpired(loginToken);

        if (expired) {
            await logoutUser();
            window.location.href = "/";
            return new Promise(() => { });
        }
    }

    const latestToken = store.getState().login.loginToken;
    config.headers['authorization'] = latestToken;

    return config;
});

BaseService.interceptors.response.use(
    response => {
        if (response.config['headers']?.encrypt) {
            if (response.data.data)
                response.data.data = JSON.parse(cryptoJs.decrypt(response.data.data))
        }
        return response
    },
    error => {
        const { response } = error;
        if (response?.status === 401) {
            const { loginToken } = store.getState().login;
            if (loginToken) {
                logoutUser();
                window.location.href = "/";
                return new Promise(() => { });
            }
        }
        return Promise.reject(error);
    }
)
export const RefreshService = axios.create({
    baseURL: process.env.REACT_APP_BASE_API_URL,
    timeout: 60000,
});

export default BaseService
